export default __webpack_public_path__ + "static/media/scan.f6ec5f51.png";